import { render, staticRenderFns } from "./TranslationsList.vue?vue&type=template&id=8bd06a84&"
import script from "./TranslationsList.js?vue&type=script&lang=js&"
export * from "./TranslationsList.js?vue&type=script&lang=js&"
import style0 from "./TranslationsList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports